import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

const HelmetWrap = (props) => {
    const pm = props.pageMeta;
    return (
    <Helmet>
        {(pm.title) ?
            <title>{pm.title}</title>
        : null}
        {(pm.title) ?
            <meta property="og:title" content={pm.title} />
        : null}
        {(pm.title) ?
            <meta name="twitter:title"  content={pm.title} />
        : null}        
        {(pm.description) ?
            <meta name="description" content={pm.description} />
        : null}
        {(pm.description) ?
            <meta property="og:description" content={pm.description} />
        : null}
        {(pm.description) ?
            <meta name="twitter:description" content={pm.description} />
        : null}        
        {(pm.image) ?
            <meta property="og:image" content={pm.image} />
        : null}
        {(pm.image) ?
            <meta name="twitter:card" content="summary_large_image" />
            : null}
        {(pm.image) ?
            <meta name="twitter:image" content={pm.image} />
            : null}                    
        {(pm.keywords) ?
            <meta name="keywords" content={pm.keywords} />
        : null}
        <meta property="og:url" content={window.location.href} />
        {/*
        <meta name="twitter:site" content="@nytimes">
        <meta name="twitter:creator" content="@SarahMaslinNir">
        <meta property="og:title" content="" />
        <meta property="og:description" content="T" />
        <meta property="og:url" content="" />
        <meta property="og:site_name" content="" />
        <meta property="og:image" content="" />
        <meta property="og:image:url" content="" />
        <meta property="og:image:width" content="" />
        <meta property="og:image:height" content="" />
        <meta property="fb:app_id" content="your_app_id" />
        */}
    </Helmet>
    );
};

export default HelmetWrap;




// WEBPACK FOOTER //
// ./src/components/dom-elements/HelmetWrap.js